export default __webpack_public_path__ + "static/media/cobrasnare.f0003d75.png";